import clsx from 'clsx'
import type { ButtonHTMLAttributes } from 'react'

type CarouselButtonNextProps = {
  direction: 'previous' | 'next'
} & ButtonHTMLAttributes<HTMLButtonElement>

export const CarouselButtonNext = ({
  className,
  direction,
  type = 'button',
  ...props
}: CarouselButtonNextProps) => {
  const label = direction === 'previous' ? 'Previous' : 'Next'

  return (
    <button
      aria-label={label}
      className={clsx(
        'carousel-button-next',
        `carousel-button-next--${direction}`,
        className,
      )}
      type={type}
      {...props}
    >
      <svg
        aria-hidden="true"
        fill="none"
        viewBox="0 0 19 13"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M17.3052 5.58525C17.7899 5.58525 18.1828 5.97818 18.1828 6.46289C18.1828 6.9476 17.7899 7.34053 17.3052 7.34053L17.3052 6.46289L17.3052 5.58525ZM0.257082 7.08348C-0.085659 6.74074 -0.0856591 6.18505 0.257082 5.84231L5.84236 0.257024C6.1851 -0.0857167 6.7408 -0.0857168 7.08354 0.257024C7.42628 0.599764 7.42628 1.15546 7.08354 1.4982L2.11884 6.46289L7.08354 11.4276C7.42628 11.7703 7.42628 12.326 7.08354 12.6688C6.7408 13.0115 6.1851 13.0115 5.84236 12.6688L0.257082 7.08348ZM17.3052 6.46289L17.3052 7.34053L0.877668 7.34053L0.877668 6.46289L0.877668 5.58525L17.3052 5.58525L17.3052 6.46289Z"
          fill="currentColor"
        />
      </svg>
    </button>
  )
}
